import NotificationSystem from './NotificationSystem';

export default NotificationSystem;